/** @format */

import Platforms from 'components/icons/Platforms';
import {platformsFromAdType} from 'helpers/adTypeHelpers';
import type {PlatformWithAll} from 'types';

import {AdTypeFromQuery} from '../../pages/Home/Settings/Notification/types';

type Props = {
  adTypes: AdTypeFromQuery[];
  bw?: boolean;
  size?: number;
};

const AdTypePlatforms = (props: Props) => {
  const {bw = false, size = 40} = props;

  const platforms = props.adTypes
    .sort()
    .map(v => platformsFromAdType(v))
    .flat() as PlatformWithAll[];

  return <Platforms bw={bw} platforms={platforms} size={size} />;
};

export default AdTypePlatforms;
